import React from 'react';
import { Box, ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { AiBorderBox } from '@shared/components/AiBorderBox';
import { AiGradientText } from '@shared/components/AiGradientText';

type HotelsEmptyStateProps = Readonly<{
  onSuggest: () => void;
}>;

const EMPTY_STATE_IMAGE = 'https://withjoy.com/assets/public/travel/admin-accommodations-empty.png';

const HotelsEmptyState: React.FC<HotelsEmptyStateProps> = ({ onSuggest }) => {
  const { tq } = useTranslation('accommodationsAdmin');

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        backgroundColor="white"
        borderRadius={pxToRem(24)}
        padding={{ _: 5, sm2: 6 }}
        maxWidth={pxToRem(384)}
        width="100%"
      >
        <Box
          as="img"
          src={EMPTY_STATE_IMAGE}
          alt=""
          width="100%"
          maxWidth={pxToRem(270)}
        />

        <Flex
          flexDirection="column"
          gap={4}
          alignItems="center"
          paddingTop={7}
          paddingBottom={4}
          textAlign="center"
        >
          <TextV2
            typographyVariant="hed4"
            color="mono14"
          >
            {tq`Add hotel recommendations to save guests time and money`}
          </TextV2>
          <TextV2
            typographyVariant="body1"
            color="mono10"
          >
            {tq`Give your guests the best rates on hotels close to your venue, available exclusively to the millions of people using Joy.`}
          </TextV2>
        </Flex>

        <Flex
          paddingTop={3}
          justifyContent="center"
        >
          <ButtonV2
            variant="ghost"
            intent="neutral"
            onClick={onSuggest}
            padding={0}
            minWidth="auto"
            height="auto"
            _hover={{ backgroundColor: 'transparent' }}
          >
            <AiBorderBox
              width="fit-content"
              borderRadius={32}
              padding={`${pxToRem(12)} ${pxToRem(20)}`}
              borderWidth={1}
            >
              <JoyAiV2 size={24} />
              <AiGradientText>{tq`Suggest Hotels Nearby`}</AiGradientText>
            </AiBorderBox>
          </ButtonV2>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default HotelsEmptyState;
